import { useAemConfig } from '@as-react/common-components';
import { usePriceViewModel } from './usePriceViewModel';
import { usePriceDiscountTag } from './usePriceDiscountTag';
export const usePriceProps = ({ priceInformation, dynamicSavingsInformation, enablePriceReference, fallbackPriceViewModel, }) => {
    var _a;
    const { currency } = useAemConfig();
    const priceViewModel = usePriceViewModel({
        prices: priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.prices,
        hasDiscount: Boolean(priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.hasDiscount),
    }, fallbackPriceViewModel, enablePriceReference);
    const tag = usePriceDiscountTag(priceInformation, dynamicSavingsInformation, enablePriceReference);
    if (!((_a = priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.prices) === null || _a === void 0 ? void 0 : _a.SELL))
        return null;
    return Object.assign(Object.assign({ currency }, priceViewModel), { tag });
};
